import type { ISEOProps } from "../types/core";

export const TermsOfServicePageSEO: ISEOProps = {
  title: "Terms of Service - Sugar Cribs",
  description:
    "Read Sugar Cribs Terms of Service. Understand the rules and guidelines for using our platform.",
};
